import { AxiosRequestConfig } from "axios";
import ApiBase from "../apiRequestBase";
import { MovieConvertRequest } from "@/apiRequests/models/communityTalk/movie/movieConvertRequest";
import { MovieConvertResponse } from "@/apiRequests/models/communityTalk/movie/movieConvertResponse";
import { MoviePresignedUrlRequest } from "@/apiRequests/models/communityTalk/movie/moviePresignedUrlRequest";
import { MovieGetConvertResultResponse } from "@/apiRequests/models/communityTalk/movie/movieGetConvertResultResponse";
import { MovieGetConvertResultRequest } from "@/apiRequests/models/communityTalk/movie/movieGetConvertResultRequest";

/**
 * 動画投稿系API。
 */
export default class MovieApiRequest {
	/**
	 * 署名付きURL取得APIのPOSTリクエスト
	 */
	public async getPresignedUrl(tenantId: string): Promise<MoviePresignedUrlRequest> {
		// リクエストの設定
		// params,headers等の設定もここで行う
		const options: AxiosRequestConfig = {
			url: `${process.env.VUE_APP_API_ENDPOINT}/movie_convert/presigned_url`,
			method: "GET",
			headers: {
				tenantId: tenantId,
			},
		};
		return (await ApiBase.requestWithApiToken<MoviePresignedUrlRequest>(tenantId, options)) as MoviePresignedUrlRequest;
	}

	/**
	 * 動画コンバートAPIのPOSTリクエスト
	 */
	public async convert(tenantId: string, request: MovieConvertRequest): Promise<MovieConvertResponse> {
		// リクエストの設定
		// params,headers等の設定もここで行う
		const options: AxiosRequestConfig = {
			url: `${process.env.VUE_APP_API_ENDPOINT}/movie_convert/execute`,
			method: "POST",
			data: request,
			headers: {
				tenantId: tenantId,
			},
		};
		return (await ApiBase.requestWithApiToken<MovieConvertResponse>(tenantId, options)) as MovieConvertResponse;
	}

	/**
	 * 動画コンバート結果取得APIのGETリクエスト
	 */
	public async getConvertResult(tenantId: string, request: MovieGetConvertResultRequest): Promise<MovieGetConvertResultResponse> {
		const options: AxiosRequestConfig = {
			url: `${process.env.VUE_APP_API_ENDPOINT}/movie_convert/result`,
			headers: {
				tenantId: tenantId,
			},
			params: request,
			method: "GET",
		};
		try {
			return (await ApiBase.request<MovieGetConvertResultResponse>(options)) as MovieGetConvertResultResponse;
		} catch {
			// 動画変換処理APIは失敗してもリトライしたいため、エラー時でも例外を投げない
			return { status: "fail", thumbnailUrl: "", thumbnailIndex: 0 };
		}
	}
}
